<template>
  <div class="main-container">
    <div class="main-form">
      <div class="form">
        <div class="form__row">
          <div class="form__input-box">
            <label class="form__label">Partner name</label>
            <input
              type="text"
              class="form__input"
              v-model="newPartnerName"
            >
          </div>
        </div>

        <div class="form__row" v-if="editPartnerError">
          <span class="creation-edition-error">{{editPartnerError}}</span>
        </div>

        <div class="form__row">
          <div class="btns-row__right-btns">
            <button v-if="$checkRoles(['Administrator'])"
                    class="ark-btn ark-btn--default" @click="editPartner">
              <span>Save Changes</span>
            </button>
          </div>
        </div>
      </div>
    </div>

    <InfoModal
      v-if="partnerIsEdited"
      :msg="'Partner was successfully edited.'"
      :onCloseModal="closeInfoModal"
    ></InfoModal>
  </div>
</template>

<script>
  import config from '../../../config'
  import Loader from '../../Loader/Loader.vue'
  import InfoModal from '../../InfoModal/InfoModal.vue'

  export default {
    components: {Loader, InfoModal},
    name: 'PartnerEditForm',
    props: ['partner'],
    data () {
      return {
        newPartnerName: '',
        editPartnerError: '',
        isLoadingBtn: false, // showing loader in the submit btn
        partnerIsEdited: false // partner edited success flag
      }
    },
    watch: {
      partner: {
        immediate: true,
        handler (newVal, oldVal) {
          if (newVal !== oldVal) {
            this.newPartnerName = newVal.name
          }
        }
      }
    },
    mounted () {
      this.newPartnerName = this.partner.name
    },
    methods: {
      editPartner: function () {
        this.$validator.validateAll().then((isValid) => {
          if (isValid) {
            // showing loader in btn
            this.isLoadingBtn = true

            const formData = new FormData()

            formData.append('partnerUpdateOptions', JSON.stringify({
              'Id': this.partner.id,
              'Name': this.newPartnerName
            }))

            this.$http.post(`${config.apiUrl}/partners/save`, formData).then(response => {
              this.isLoadingBtn = false
              this.partnerIsEdited = true
            }, error => {
              console.log(error, 'edit partner error')
              this.isLoadingBtn = false
              this.editPartnerError = error.body.Message ? error.body.Message : 'Something went wrong with edition of the Partner'
            })
          }
        })
      },
      closeInfoModal: function () {
        this.partnerIsEdited = false
        this.$emit('partner-edited')
      }
    }
  }
</script>
